export default "__VITE_ASSET__BerrLSXS__"